<template>
  <div class="recharge-history-box">
    <NvHeader text-color="white" title="Recharge History" />

    <div class="content">
      <div class="flex-center coin-content">
        <img src="@/assets/images/gcoin.png" width="40px" />
        <span class="coin-text">{{ myCoins }}</span>
      </div>
      <div class="menu-box">
        <van-cell
          title-class="cell-title"
          @click="handleMenuClick('/me/deposit-history?type=deposit')"
          center
          title="Deposit History"
          is-link
        />
        <van-cell
          @click="handleMenuClick('/me/usage-history?type=usage')"
          title-class="cell-title"
          center
          title="Usage History"
          is-link
        />
      </div>
    </div>
  </div>
</template>

<script>
import NvHeader from "@/components/widget/NvHeader";

export default {
  components: {
    NvHeader
  },
  computed: {
    myCoins() {
      return this.$store.state.user.coins_amount || 0;
    }
  },
  data() {
    return {};
  },
  methods: {
    handleMenuClick(path) {
      this.navigateWithAuth(() => {
        this.$router.push({ path });
      });
    }
  },
  mounted() {
    window.$event("Recharge_History_Page_Show", {});
  }
};
</script>

<style lang="scss" scoped>
.recharge-history-box {
  &::v-deep {
    .van-nav-bar {
      background-color: #ffd76d;
      padding: 5px;
    }
    .content {
      margin-top: 50px;
    }
    .coin-content {
      background: linear-gradient(180deg, #ffd76d, #ff9541);
      height: 20vh;
      padding-bottom: 45px;
      .coin-text {
        color: white;
        font-size: $fs-main * 2;
        margin-left: 8px;
      }
    }
    .menu-box {
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      margin-top: -20px;
      background: white;
      padding: 10px;
      .cell-title {
        padding-top: 6px;
        padding-bottom: 6px;
        font-weight: 400;
        color: $fc-black;
        font-size: $fs-main;
      }
    }
  }
}
</style>
